export const GET_PASSAGES = '[PASSAGES] GET_PASSAGES'
export const GET_PASSAGE = '[THEORIES] GET_PASSAGE'
